import { useEffect, useState } from 'react';
import { api } from '../lib/api';

// Static seed shown until the first live fetch resolves (or if the site is
// too new to have 30 days of search history yet) so the trending row is
// never empty.
const FALLBACK_TERMS = ['Fantasy', 'Sci-Fi', 'Self-Help', 'Romance', 'Business'];

const POLL_INTERVAL_MS = 20 * 1000;

// Most-searched terms from real reader activity, for the homepage trending
// tags. Polls like useLiveReaderCount so a search someone else just made
// shows up here without the page needing a refresh.
export function useTrendingSearches() {
  const [terms, setTerms] = useState(FALLBACK_TERMS);

  useEffect(() => {
    let cancelled = false;
    const fetchTerms = () => {
      api.get('/books/trending-searches?limit=5')
        .then((data) => { if (!cancelled && data.terms?.length) setTerms(data.terms); })
        .catch(() => {});
    };

    fetchTerms();
    const interval = setInterval(fetchTerms, POLL_INTERVAL_MS);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return terms;
}
